export interface IUsernameGrp {
  Username?: string// 553
}
